import React from 'react'
import styles from './NewCommunityPopup.module.scss'
import ReactModal from 'react-modal'
import { useAtom } from 'jotai'
import { NewCommunityPopupAtom } from 'showMessageMenuAtom'

const NewCommunityPopup = () => {
    const [isOpen, setIsOpen] = useAtom(NewCommunityPopupAtom);
    const [currentStep, setCurrentStep] = React.useState(1);
    const videoRef = React.useRef<any>(null);

    React.useEffect(() => {
        if (isOpen) {
            setCurrentStep(1);
            if (videoRef.current) {
                // Reset video to start when reopening the modal
                videoRef.current.currentTime = 0;
            }
        }
    }, [isOpen])

    // Content for each step
    const stepContent: any = {
        1: {
            title: 'Welcome to GroupApp',
            description: 'Get familiar with GroupApp by watching our quick overview video.',
            buttonText: 'Continue',
        },
        2: {
            title: 'Schedule a 1:1 onboarding call',
            description: 'Get personalized guidance on setting up your community for success, plus get a step-by-step launch plan.',
            buttonText: 'Book onboarding',
        }
    };

    const closeModal = () => {
        setIsOpen(false);
    };

    const handleStepClick = (step: any) => {
        setCurrentStep(step);
        // Video continues playing when changing steps
    };

    const handleNextClick = () => {
        if (currentStep < 2) {
            setCurrentStep(currentStep + 1);
        } else {
            window.open('https://calendly.com/d/crz3-6fc-q39', '_blank')
        }
    };

    return (
        <ReactModal
            isOpen={isOpen}
            onRequestClose={closeModal}
            className={styles.modal}
            overlayClassName={styles.overlay}
            shouldCloseOnOverlayClick={true}
            id='NewCommunityPopup'
            style={{
                overlay: {
                    backgroundColor: "rgba(0, 0, 0, 0.2)",
                    zIndex: 99999,
                }
            }}
        >
            <div className={styles.modalContent}>

                <div className={styles.videoContainer} style={{ position: 'relative', paddingBottom: '56.25%', height: 0 }}>
                    <div style={{ padding: '56.25% 0 0 0', position: 'relative' }}>
                        <iframe
                            src="https://player.vimeo.com/video/1093860181?badge=0&autopause=0&player_id=0&app_id=58479&dnt=1"
                            frameBorder="0"
                            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
                            style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%' }}
                            title="Getting Started - Onboarding"
                            allowFullScreen
                        ></iframe>
                    </div>
                </div>

                {/* Step Indicator */}
                <div className={styles.stepIndicator}>
                    <div className={styles.stepContainer}>
                        <span className={styles.stepText}>Step {currentStep} of 2</span>
                        <div className={styles.stepDots}>
                            <button
                                onClick={() => handleStepClick(1)}
                                className={`${styles.stepDot} ${currentStep === 1 ? styles.active : ''}`}
                                aria-label="Go to step 1"
                            />
                            <button
                                onClick={() => handleStepClick(2)}
                                className={`${styles.stepDot} ${currentStep === 2 ? styles.active : ''}`}
                                aria-label="Go to step 2"
                            />
                        </div>
                    </div>
                </div>

                {/* Content Section - Changes based on step */}
                <div className={styles.contentSection}>
                    <h2 className={styles.title}>{stepContent[currentStep].title}</h2>
                    {
                        stepContent[currentStep].description &&
                        <p className={styles.description}>{stepContent[currentStep].description}</p>
                    }
                    <button
                        onClick={handleNextClick}
                        className={styles.ctaButton}
                    >
                        {stepContent[currentStep].buttonText}
                    </button>
                </div>
            </div>
        </ReactModal >
    )
}

export default NewCommunityPopup